import { render, staticRenderFns } from "./Restricciones.vue?vue&type=template&id=6cd986de"
import script from "./Restricciones.vue?vue&type=script&lang=js"
export * from "./Restricciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports